import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";

const firebaseConfig = {
    // Prod DB
    apiKey: "AIzaSyDdvJCDiuzKYeXnkaPOX6lBS9oG0qjxIHk",
    authDomain: "dimora-admin.firebaseapp.com",
    projectId: "dimora-admin",
    storageBucket: "dimora-admin.firebasestorage.app",
    messagingSenderId: "20019469700",
    appId: "1:20019469700:web:65982e5e0d5ad2f26bd1d1",
    measurementId: "G-28XYDR2BNV"




    // Test DB

    // apiKey: "AIzaSyBAtErS45J2oxX4H3lK5D1dURB1GOdYkZg",
    // authDomain: "baglami-83fc7.firebaseapp.com",
    // projectId: "baglami-83fc7",
    // storageBucket: "baglami-83fc7.firebasestorage.app",
    // messagingSenderId: "694452420376",
    // appId: "1:694452420376:web:b2c0f26b3dafa3f018e86d",
    // measurementId: "G-G14J96S6C7"
    
};


// 🔥 Initialize app FIRST
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);

// 🔥 Then initialize Firestore
const db = getFirestore(app);

// ✅ Export AFTER initialization
export { db, auth };
